// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__1mFDz","radius":"Button_radius__2OnlQ","danger":"Button_danger__38-Sl","outline":"Button_outline__37TIJ","primary":"Button_primary__1wjhV"};